// import { getUnlimitedSubscriptionPlan } from '@/services/order.service.js';
import { listSubscriptionPlans } from '@/api/subscription-plans.js';

const state = {
  plans: null,
};

const getters = {
  getPlanById: state => (id) => {
    if (state.plans === null) {
      return null;
    }

    if (!id) {
      return null;
    }

    id = id.replace('-', '_').toLowerCase();

    return state.plans.find(plan => plan.id === id);
  },
};

const actions = {
  async getPlans({ commit }) {
    return listSubscriptionPlans().then((response) => {
      commit('setPlans', response.data.data);
      return response;
    });
  },
};

const mutations = {
  setPlans(state, data) {
    state.plans = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
